// extracted by mini-css-extract-plugin
module.exports = {"textBody":"landing-page-module--textBody--nYao3","textHeader":"landing-page-module--textHeader--3yr8u","textQuestion":"landing-page-module--textQuestion--3yeoC"};